import { SmsTemplatePurpose } from '../../../../models/Scheduling'

export interface SmsTemplateInfo {
  purpose: SmsTemplatePurpose
  label: string
  description: string
  note: string
}

export const SMS_TEMPLATE_PURPOSES: SmsTemplateInfo[] = [
  {
    purpose: SmsTemplatePurpose.MEETING_REMINDER,
    label: 'Meeting reminder',
    description: 'Sent before meetings at the times set in Reminders.',
    note: 'Sent at the times set in Reminders. Not sent during quiet hours. Meeting reminder emails still go out.',
  },
  {
    purpose: SmsTemplatePurpose.CANCELLATION_NOTICE,
    label: 'Cancellation',
    description: 'Sent when you cancel a meeting.',
    note: 'Not sent during quiet hours. Cancellation emails still go out.',
  },
]
